import { render, staticRenderFns } from "./reactionControl.vue?vue&type=template&id=6a1f8b80&scoped=true&"
import script from "./reactionControl.vue?vue&type=script&lang=js&"
export * from "./reactionControl.vue?vue&type=script&lang=js&"
import style0 from "./reactionControl.vue?vue&type=style&index=0&id=6a1f8b80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1f8b80",
  null
  
)

export default component.exports